<script setup lang="ts">
import type { Component } from 'vue'

defineProps<{
  icon: Component
  text: string
}>()
</script>

<template>
  <div
    class="group/item flex w-full cursor-pointer items-center gap-2.5 bg-white px-4 py-2 hover:bg-lochmara-50"
  >
    <component :is="icon" class="h-4 w-4 text-black-400 group-hover/item:text-lochmara-600" />
    <div class="text-sm text-black-900 group-hover/item:text-lochmara-600">
      {{ text }}
    </div>
  </div>
</template>
